import { render, staticRenderFns } from "./ImportExportProducts.vue?vue&type=template&id=5a82557a"
import script from "./ImportExportProducts.vue?vue&type=script&lang=js"
export * from "./ImportExportProducts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports